export const DEFAULT_TABLE_ACTIONS = [
  'edit',
  'delete',
];

export const DELETE_TABLE_ACTIONS = [
  'delete',
];
